import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { GetChatMessagesResponse, GetChatsResponse } from "./models";

export const getChats = async (body: { page: number, searchValue: string }): Promise<GetChatsResponse | null> => {
    let config = getConfig()
    let result: GetChatsResponse | null = null
    try {
        const response = await axios.get(`/chat?page=${body.page}&searchValue=${body.searchValue}`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}


export const getChatMessages = async (body: { page: number, chatId: string }): Promise<GetChatMessagesResponse | null> => {
    let config = getConfig()
    let result: GetChatMessagesResponse | null = null
    try {
        const response = await axios.get(`/chat/chat-messages/${body.chatId}?page=${body.page}`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}


export const getPlayerChats = async (body: { playerId: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.get(`/chat/get-player-chats?playerid=${body.playerId}`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}

export const createChat = async (body: { message: string, type: string, creatorType: string, PlayerId: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/chat/new-chat`, body, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}

export const getUnseenChats = async (): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.get(`/chat/unseen-chats`, config)
        result = response.data
    } catch (error) {
        console.log(error, 'error')
    }

    return result
}